import BaseObject from '../../base/base_object';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';

export default class GamesDiagnosticMessages extends BaseObject {
    static CLASS = 'GamesDiagnosticMessages';

    init(params) {
        super.init(params);
        Event.on(SYSTEM_EVENTS.RESTRICTIONS_CHANGED, this._onRestrictionsChanged, this);
    }


    _onRestrictionsChanged() {
        this._gameRestrictedMessages = {};
    }


    _gameRestrictedMessages = {};
    logGameRestricted(gameType, message) {
        this._gameRestrictedMessages[gameType] = message;
        this.logger.debug(message);
    }


    _gameFilteredByPlatformTypeMessges = {};
    logGameFilteredByPlatformType(gameType, message) {
        this._gameFilteredByPlatformTypeMessges[gameType] = message;
        this.logger.debug(message);
    }

    _gameNotApprovedMessages = {}
    logGameNotApproved(gameType, message) {
        this._gameNotApprovedMessages[gameType] = message;
        this.logger.debug(message);
    }

    getAllDiagnosticMessages() {
        return Object.values(this._gameRestrictedMessages)
                     .concat(Object.values(this._gameFilteredByPlatformTypeMessges))
                     .concat(Object.values(this._gameNotApprovedMessages));
    }


}
